import React from 'react';
import {toJS} from 'mobx';
import './index.scss';

import {api} from '../../../../../functions/api'


import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import CustomInput from '../../../../../components/basic/input'
import TextField from '@material-ui/core/TextField'
import CustomButton from '../../../../../components/basic/CustomButton';

import { inject, observer } from 'mobx-react';

import Grid from '@material-ui/core/Grid';
import { MenuItem } from '@material-ui/core';

@inject('translate')
@inject('internal')
@observer

export default class CreateNewClient extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loadingBtn: false,
            message: "",
            openSnackbar: false,
            privilegies: (4).toString()
        }
    }


    componentDidMount() {
        if(this.props.idUser) {
            this.setEditUser()
        }
    }
    

    privilegies = [
        {
          value: '3',
          label: this.props.translate.i18n.MODULES.CLIENTS.ROLES.MANAGER,
        },
        {
          value: '4',
          label: this.props.translate.i18n.MODULES.CLIENTS.ROLES.MEMBER,
        }
      ];

    handleChange = name => event => {
        this.setState({
          [name]: event.target.value,
        });
    };
    
    handleCreateOrEditUser = async () => {

        this.setState({loadingBtn: true})
        let first_name = this.first_name.state.value;
        let last_name = this.last_name.state.value;
        let email = this.email.state.value;
        let phone = this.phone.state.value;
        
        let idClient = toJS(this.props.routerData.match.params.idClient)

        let url = 'clients/'+idClient+"/members"
        
        let method = "post";
        if(this.props.idUser) {
            url += "/" + this.props.idUser
            method = "patch"
        }


        let create_data = await api({
            //method:'post',
            //url:'clients/'+idClient+"/members",
            method: method,
            url: url,
            authorization: this.props.internal.user.access_token,
            params: {
                first_name: first_name,
                last_name: last_name,
                email: email,
                role_id: this.state.privilegies,
                //passwordy sa nebudu zadavat pri vytvarani noveho administratora
                // password: 123456789,
                // password_confirmation: 123456789,
                data: {
                    // alternate_email: this.alternate_email.state.value,
                    // phone: this.phone.state.value,
                    // fax: this.fax.state.value
                    // alternate_email: "testtest@test.com",
                    phone: phone
                    // fax: "12345431"
                }
            }
        })

        if(create_data.success === true) {
            this.setState({message: create_data.data.message, openSnackbar: true})
            this.props.showSnackbar(create_data.data.message, true)
            if(this.props.idUser) {
                let dataEdit = {
                    edit: false,
                    id: null
                }
                this.props.internal.setActionEdit(dataEdit)
            }
        }
        else if(create_data.success === false && create_data.status === 201) {
            this.props.showSnackbar(create_data.data.message, true, true);
        }
        else {
            let resultError = "";
            for(let error in create_data.data.data.errors)
            {
                resultError += create_data.data.data.errors[error] + " "
            }
            //this.setState({message: resultError, openSnackbar: true})
            // this.props.showSnackbar(this.state.message, this.state.openSnackbar, false)
            this.props.showSnackbar("", false, false)
            this.props.internal.setSnackbar(resultError, true)
        }
        
        this.setState({loadingBtn: false})
    }

    setEditUser () {
        let users = toJS(this.props.internal.dataForTable.data)
            for(let i=0; i < users.length; i++) {
                if(users[i].id === this.props.idUser) {
                    this.editUser = users[i]
                    this.setState({privilegies: (users[i].role_id).toString()})
                    break
                }
            }
    }
    
    editUser = {};

    render() {
        return (
            this.state.privilegies !== null?
            <Dialog
                open={this.props.open}
                onClose={this.props.onClose}
                aria-labelledby="form-dialog-title"
                className={'create-new-user'}
            >
                <DialogTitle id="form-dialog-title">{this.props.title}</DialogTitle>
                <DialogContent>
                <Grid container spacing={24}>
                    <Grid item className={'grid-item'} xs={12} sm={6}>
                    <CustomInput
                        ref={ref => this.first_name = ref}
                        text={this.props.translate.i18n.GLOBAL.USER.FIRST_NAME}
                        value={this.props.idUser ? this.editUser.first_name : ""}
                        id={'firstname'}
                        className={"mr-10 w-100"}
                        required
                    />
                    </Grid>
                    <Grid item className={'grid-item'} xs={12} sm={6} >
                    <CustomInput
                        ref={ref => this.last_name = ref}
                        text={this.props.translate.i18n.GLOBAL.USER.LAST_NAME}
                        value={this.props.idUser ? this.editUser.last_name : ""}
                        id={'lastname'}
                        className={"mr-10 w-100"}
                        required
                    />
                </Grid>
                    <Grid item className={'grid-item'} xs={12} sm={6} >
                    <CustomInput
                        ref={ref => this.email = ref}
                        text={this.props.translate.i18n.GLOBAL.CONTACT.EMAIL}
                        value={this.props.idUser ? this.editUser.email : ""}
                        id={'email'}
                        className={"w-100"}
                        required
                    />
                    </Grid>
                    <Grid item className={'grid-item'} xs={12} sm={6} >
                    <CustomInput
                        ref={ref => this.phone = ref}
                        text={this.props.translate.i18n.GLOBAL.CONTACT.PHONE}
                        value={this.props.idUser ? this.editUser.phone : ""}
                        id={'phone'}
                        className={"w-100"}
                        
                    />
                    </Grid>
                    <Grid item className={'grid-item'} xs={12} sm={6} >
                    <TextField
                        id="standard-select-currency-native"
                        select
                        label={this.props.translate.i18n.MODULES.CLIENTS.ROLE_ID}
                        value={this.state.privilegies}
                        // defaultValue={this.state.privilegies}
                        onChange={this.handleChange('privilegies')}
                        className={"mr-10 w-100 custom-select-select"}
                        SelectProps={{
                            MenuProps: {
                            },
                          }}
                        margin="normal"
                        >
                        {this.privilegies.map(option => (
                            
                            <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
                        ))}
                    </TextField>
                    </Grid>
                </Grid  >
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.onClose} className={'gray-text'}>
                    {this.props.translate.i18n.GLOBAL.BUTTONS.CANCEL}
                    </Button>
                    {/* <Button onClick={this.handleCreateOrEditUser} className={'orange-text'}>
                    {this.props.translate.i18n.GLOBAL.BUTTONS.SAVE}
                    </Button> */}

                    <CustomButton
                        justText
                            progressBar={this.state.loadingBtn}
                            onClick={this.handleCreateOrEditUser}
                            mystyle={'btn-white-bg width-80'}
                            title={this.props.translate.i18n.GLOBAL.BUTTONS.SAVE}
                        />
                </DialogActions>
                
            </Dialog>
            :
            null
            
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/clients/detail/users/add/index.js